import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function MaskIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4.89125 15.9991H3"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.1417 15.9991H27.2505"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9368 4.73456H14.2024V1H17.9368V4.73456Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2686 21.6005C14.2686 21.5639 14.2389 21.5341 14.2021 21.5341C14.1654 21.5341 14.1357 21.5639 14.1357 21.6005C14.1358 21.6371 14.1655 21.6669 14.2021 21.6669C14.2388 21.6669 14.2685 21.6371 14.2686 21.6005Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M10.537 21.6005C10.537 21.5639 10.5074 21.5341 10.4706 21.5341C10.4339 21.5341 10.4042 21.5639 10.4042 21.6005C10.4043 21.6371 10.434 21.6669 10.4706 21.6669C10.5073 21.6669 10.537 21.6371 10.537 21.6005Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M14.2686 25.3354C14.2686 25.2987 14.2389 25.269 14.2021 25.269C14.1654 25.269 14.1357 25.2987 14.1357 25.3354C14.1358 25.372 14.1655 25.4018 14.2021 25.4018C14.2388 25.4018 14.2685 25.372 14.2686 25.3354Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M18.0039 21.6005C18.0039 21.5639 17.9742 21.5341 17.9375 21.5341C17.9008 21.5341 17.8711 21.5639 17.8711 21.6005C17.8711 21.6371 17.9008 21.6669 17.9375 21.6669C17.9742 21.6669 18.0039 21.6371 18.0039 21.6005Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M21.7393 21.6005C21.7393 21.5639 21.7096 21.5341 21.6729 21.5341C21.6361 21.5341 21.6064 21.5639 21.6064 21.6005C21.6065 21.6371 21.6362 21.6669 21.6729 21.6669C21.7095 21.6669 21.7392 21.6371 21.7393 21.6005Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M14.2686 8.46563C14.2686 8.42899 14.2389 8.39922 14.2021 8.39922C14.1654 8.39923 14.1357 8.42899 14.1357 8.46563C14.1358 8.50224 14.1655 8.53202 14.2021 8.53203C14.2388 8.53203 14.2685 8.50225 14.2686 8.46563Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M18.0039 8.46563C18.0039 8.42899 17.9742 8.39922 17.9375 8.39922C17.9008 8.39923 17.8711 8.42899 17.8711 8.46563C17.8711 8.50224 17.9008 8.53202 17.9375 8.53203C17.9742 8.53203 18.0039 8.50225 18.0039 8.46563Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M18.0039 25.3354C18.0039 25.2987 17.9742 25.269 17.9375 25.269C17.9008 25.269 17.8711 25.2987 17.8711 25.3354C17.8711 25.372 17.9008 25.4018 17.9375 25.4018C17.9742 25.4018 18.0039 25.372 18.0039 25.3354Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M17.9382 3.00483C23.2368 3.80695 27.2743 8.12665 27.2743 15.0659C27.2743 22.8005 22.2584 31 16.071 31C9.88359 31 4.86768 22.8005 4.86768 15.0659C4.86768 8.12665 8.90517 3.80695 14.2038 3.00483"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2047 15.067C14.2047 16.6139 12.0171 17.8679 10.4702 17.8679C8.92338 17.8679 8.60303 16.6139 8.60303 15.067C8.60303 13.5201 8.92338 12.2661 10.4702 12.2661C12.0171 12.2661 14.2047 13.5201 14.2047 15.067Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5396 15.067C23.5396 16.6139 23.2192 17.8679 21.6724 17.8679C20.1255 17.8679 17.9379 16.6139 17.9379 15.067C17.9379 13.5201 20.1255 12.2661 21.6724 12.2661C23.2192 12.2661 23.5396 13.5201 23.5396 15.067Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
}
